export default __webpack_public_path__ + "static/media/Step 5 Image 1.78030edb.png";